import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useMutation } from '@apollo/client/react'

import { CrossIcon } from '@pleio/icons/cross'

import Button from 'js/components/Button'
import Flexer from 'js/components/Flexer/Flexer'
import FormItem from 'js/components/Form/FormItem'
import IconButton from 'js/components/IconButton'
import Modal from 'js/components/Modal/Modal'
import UserLink from 'js/components/UserLink'

import styles from './Attendee.module.css'
import { DELETE_ATTENDEE } from './Attendee.mutations'

const Attendee = ({ containerGuid, containerCanEdit, entity }) => {
    const { t } = useTranslation()

    const [showRemoveAttendeeModal, setShowRemoveAttendeeModal] =
        useState(false)
    const toggleShowRemoveAttendeeModal = () =>
        setShowRemoveAttendeeModal(!showRemoveAttendeeModal)

    const [mutate] = useMutation(DELETE_ATTENDEE)

    const submitRemoveAttendee = async ({ updateSubEvents }) => {
        await mutate({
            variables: {
                input: {
                    guid: containerGuid,
                    emailAddresses: [email],
                    updateSubEvents,
                },
            },
            refetchQueries: ['EventItem', 'AttendeesList'],
        })
            .then(() => {
                toggleShowRemoveAttendeeModal()
            })
            .catch((errors) => {
                console.error(errors)
            })
    }

    const defaultValues = {
        updateSubEvents: false,
    }

    const {
        control,
        handleSubmit,
        formState: { isValid, isSubmitting },
    } = useForm({ mode: 'onChange', defaultValues })

    const { email, isAttendingSubEvents } = entity

    return (
        <>
            <div className={styles.wrapper}>
                <UserLink entity={entity} style={{ width: '100%', flex: 1 }} />
                {containerCanEdit && (
                    <div className={styles.removeUser}>
                        {email}
                        <IconButton
                            size="large"
                            bgOffset="sm"
                            variant="secondary"
                            aria-label={t('entity-event.remove-attendee')}
                            tooltip={t('action.remove')}
                            onClick={toggleShowRemoveAttendeeModal}
                        >
                            <CrossIcon />
                        </IconButton>
                    </div>
                )}
            </div>

            <Modal
                isVisible={showRemoveAttendeeModal}
                onClose={toggleShowRemoveAttendeeModal}
                title={t('entity-event.remove-attendee')}
                size="small"
            >
                <form onSubmit={handleSubmit(submitRemoveAttendee)}>
                    {t('entity-event.remove-attendee-confirm', {
                        email,
                    })}
                    {isAttendingSubEvents && (
                        <FormItem
                            control={control}
                            type="checkbox"
                            name="updateSubEvents"
                            label={t(
                                'entity-event.remove-attendee-all-activities',
                            )}
                            size="small"
                            style={{ marginTop: '8px' }}
                        />
                    )}
                    <Flexer mt>
                        <Button
                            size="normal"
                            variant="tertiary"
                            type="button"
                            onClick={toggleShowRemoveAttendeeModal}
                        >
                            {t('action.no-back')}
                        </Button>
                        <Button
                            size="normal"
                            variant="primary"
                            type="submit"
                            disabled={!isValid}
                            loading={isSubmitting}
                        >
                            {t('action.yes-confirm')}
                        </Button>
                    </Flexer>
                </form>
            </Modal>
        </>
    )
}

export default Attendee
